import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function MobilePostAdCTA() {
  const navigate = useNavigate();
  return (
    <section className="px-3 pt-4">
      <div className="rounded-2xl border bg-card shadow-sm p-4 flex items-center gap-3">
        <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
          <Building2 className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold leading-tight">Looking to sell or rent out your property?</p>
          <Button
            variant="outline"
            size="sm"
            className="mt-2 h-8 text-xs font-semibold border-primary text-primary"
            onClick={() => navigate('/dashboard/properties/new')}
          >
            Post an Ad
          </Button>
        </div>
      </div>
    </section>
  );
}
